<template>
    <div class="GameMatch">
        <!-- 下拉框选择部分 -->
        <!-- <div class="GameMatch_header">
            <div class="font_w font_si">{{PhaseName}}</div>
            <div>
                <el-select v-model="TeamValue" placeholder="请选择" @change="handleChange">
                    <el-option
                    v-for="item in TeamArr"
                    :key="item.TeamID"
                    :label="item.TeamName"
                    :value="item.TeamID"
                    >
                    </el-option>
                </el-select>
            </div>
        </div> -->
        <!-- tab部分 -->
        <div>
            <el-row>
                <el-button v-for="(i,index) in PhaseArr" :key="index" :class="active == index ? 'activeCLass' : ''" @click="handleGroup(i.PhaseID,index)">{{i.PhaseDes}}</el-button>
                <!-- <el-button>第三阶段-三、四名决赛</el-button>
                <el-button>第三阶段-半决赛</el-button>
                <el-button>第三阶段-冠亚军决赛</el-button> -->
            </el-row>
        </div>
        <!-- 内容部分 -->
        <div class="GameMatch_box">
            <div class="GameMatch_box_data" >
                <el-card class="box-card">
                    <!-- <div slot="header" class="clearfix">
                        <span>{{o.RoundDes}}</span>
                    </div> -->
                    <div v-if="TeamList.length > 0">
                        <el-collapse class="fold_class" v-for="item in TeamList" :key="item.TeamID" v-model="activeNames" @change="handleChangea">
                            <el-collapse-item :title="item.TeamName" :name="item.TeamID">
                                <el-table
                                    :data="item.AthleteList"
                                    stripe
                                    size="mini"
                                    :header-cell-style="{'textAlign': 'center','background':'#eaeaea'}"
                                    :cell-style="{ textAlign: 'center' }"
                                    style="width: 100%">
                                    <el-table-column
                                    prop="Bib"
                                    label="号码"
                                    width="80">
                                    </el-table-column>
                                    <el-table-column
                                    prop="AthleteName"
                                    label="运动员姓名"
                                    width="200">
                                    </el-table-column>
                                    <el-table-column
                                    prop="BirthDate"
                                    label="出生日期"
                                    width="100">
                                    </el-table-column>
                                    <el-table-column
                                    prop="Age"
                                    label="年龄"
                                    width="80">
                                    </el-table-column>
                                    <el-table-column
                                    prop="Height"
                                    label="身高(cm)">
                                    </el-table-column>
                                    <el-table-column
                                    prop="Weight"
                                    label="体重(kg)">
                                    </el-table-column>
                                    <el-table-column
                                    prop="HighestSpike"
                                    label="扣球(cm)">
                                    </el-table-column>
                                    <el-table-column
                                    prop="ReachBlock"
                                    label="拦网(cm)">
                                    </el-table-column>
                                    <el-table-column
                                    prop="Position"
                                    label="场上位置">
                                    </el-table-column>
                                </el-table>
                                
                                <div class="staff_class">
                                    <span :style="{'font-weight':'bold'}">领队：</span>
                                    <span v-for="(o,index) in item.TeamLeaderList" :key="index">
                                        {{ o }}<span v-if="index < item.TeamLeaderList.length -1">、</span>
                                    </span>
                                    
                                </div>
                                <div class="staff_class">
                                    <span :style="{'font-weight':'bold'}">主教练：</span> 
                                    <span v-for="(o,index) in item.CoachList" :key="index">
                                        {{ o }}<span v-if="index < item.CoachList.length -1">、</span>
                                    </span>
                                </div>
                                <div class="staff_class">
                                    <span :style="{'font-weight':'bold'}">助理教练：</span>
                                    <span v-for="(o,index) in item.AssistanCoachList" :key="index">
                                        {{ o}}<span v-if="index < item.AssistanCoachList.length -1">、</span>
                                    </span>
                                </div>
                                <div class="staff_class">
                                    <span :style="{'font-weight':'bold'}">医生：</span>
                                    <span v-for="(o,index) in item.DoctorList" :key="index" >
                                        {{ o }}<span v-if="index < item.DoctorList.length -1">、</span>
                                    </span>
                                </div>
                            </el-collapse-item>
                            <!-- <el-collapse-item title="反馈 Feedback" name="2">
                                <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
                                <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
                            </el-collapse-item>
                            <el-collapse-item title="效率 Efficiency" name="3">
                                <div>简化流程：设计简洁直观的操作流程；</div>
                                <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
                                <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
                            </el-collapse-item>
                            <el-collapse-item title="可控 Controllability" name="4">
                                <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
                                <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
                            </el-collapse-item> -->
                        </el-collapse>
                        
                    </div>
                    <el-empty v-else description="暂无数据啦..."></el-empty>
                </el-card>
                
            </div>
        </div>

    </div>
</template>

<script>
import http from '@/assets/js/http.js';
export default {
    data() {
      return {
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        TeamValue: '-1',
        tableData: [{
            id: '12987122',
            name: '好滋好味鸡蛋仔',
            category: '江浙小吃、小吃零食',
            desc: '荷兰优质淡奶，奶香浓而不腻',
            address: '上海市普陀区真北路',
            shop: '王小虎夫妻店',
            shopId: '10333'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }],
        PhaseID: '',
        PhaseName: '',
        PhaseArr: [],
        RoundArr: [],
        autofocus: true,
        my_data: null,
        active: 0,
        TeamArr: [],
        activeNames: ['0'],
        TeamList: [],
      };
    },
    props:['phase'],
    watch: {
        // PhaseID(newVal,oldVal){
        //     // console.log('这是新值111:',newVal)
        //     // console.log('这是laozh1111i:',oldVal)
        //     // this.GetEventStatHome();//获取首页9大统计数据接口
        // }
        phase(newVal,oldVal){
            // console.log('这是新值111:'+newVal)
            // console.log('这是laozh1111i:'+oldVal)
            this.active = 0;
            this.GetMatchResultList(newVal,this.TeamValue)//获取比赛成绩列表
        },
        $route: { // 亲测有效,我是用来监听query参数变化
            handler(newVal,oldVal) {
                // this.id = this.$route.query.id;
                // this.getDetail();
                // console.log('这是新值:',newVal)
                // console.log('这是laozhi:',oldVal)
                //深度监听，同时也可监听到param参数变化
                let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
                this.PhaseID = params.phaseID;
                this.PhaseName = params.phaseName;
                // console.log(params)
            },
            deep: true,
        }
    },
    computed: {
        // 读取和设置
        // aPlus: {
        //     get: function () {
        //         return console.log(this.PhaseID)
        //     },
        // // set: function (v) {
        // //     this.a = v - 1
        // // }
        // }
    },
    created(){
        let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
        this.my_data = params;
        this.PhaseID = params.phaseID;
        this.PhaseName = params.phaseName;
        console.log(params)
        this.GetSportTeamList(this.my_data.EventID)//获取队伍列表
        this.GetTeamDetail(this.my_data.EventID);//获取队伍详细信息
    },
    mounted(){
        // this.PhaseID = this.$cookie.get('PhaseID');
        // this.GetMatchResultList(this.PhaseID,this.TeamValue)//获取比赛成绩列表
    },
    beforeUpdate(){
        // console.log(this.PhaseID)
        // console.log(this.$cookie.get('PhaseID'))
    },
    methods: {
        TableRowClassName({row, rowIndex}) {
            if ((rowIndex+1)%2==0) {
                return 'statistics-warning-row';
            } else {
                return '';
            }
        },
        //折叠面板的点击事件
        handleChangea(val) {
            console.log(val);
        },
        GetTeamDetail(EventID){//获取队伍详细信息
            http.GetTeamDetail('GetTeamDetail',EventID).then(res=>{////获取队伍详细信息
                console.log(res)
                if(res.Status === 1){

                    // for(let i = 0; i < res.DataResult.length; i++){
                    //     for(let j = 0;j < res.DataResult[i].AssistanCoachList.length; j++){
                    //         let item = res.DataResult[i].AssistanCoachList[j];
                    //         res.DataResult[i]['AssistanCoach'] += item+','
                    //     }
                    // }
                    this.TeamList = res.DataResult;
                }else{
                    this.TeamList = [];
                    this.$message.error({
                        message:'获取信息失败!',
                        duration: 1500,
                        showClose: true,
                    });
                }
            })
        },





        handleChange(value){//选择队伍的下拉
            // console.log(value)
            this.TeamValue = value;
            // this.GetMatchResultList(this.PhaseID,value)//获取比赛成绩列表
        },
        handleGroup(val,index){//点击上面的组别
            this.active = index;
            for(let i = 0; i < this.PhaseArr.length;i++){
                let item = this.PhaseArr[i];
                if(val == item.PhaseID){
                    this.RoundArr = item.RoundMatchList;
                }
            }
        },
        GetMatchResultList(PhaseID,TeamID){//获取比赛成绩列表
            http.GetMatchResultList(PhaseID,TeamID).then(res=>{////获取比赛成绩列表
                console.log(res)
                // if(res.Status == 1){
                //     // this.JsonData = res.DataResult;
                //     if(res.DataResult.length > 0){ 
                //         this.PhaseArr = res.DataResult;
                //         this.RoundArr = this.PhaseArr[0].RoundMatchList;
                //     }else{
                //         this.PhaseArr = [];
                //         this.$message.error('暂无数据啦');
                //     }
                    
                // }else if(res.Status == 0){
                //     this.$message.error({message:'暂无数据!',duration: 1500,showClose: true,});
                // }else{
                //     this.$message.error({
                //         message:'获取信息失败!',
                //         duration: 1500,
                //         showClose: true,
                //     });
                // }
            })
        },
        GetSportTeamList(EventID){//获取队伍列表
            http.GetSportTeamList(EventID).then(res=>{////获取队伍列表
                // console.log(res)
                if(res.Status == 1){
                    // this.JsonData = res.DataResult;
                    if(res.DataResult.length > 0){ 
                        this.TeamArr = res.DataResult;
                        this.TeamValue = res.DataResult[0].TeamID;
                        // this.RoundArr = this.PhaseArr[0].RoundMatchList;
                    }else{
                        this.TeamArr = [];
                        this.$message.error({
                            message:'暂无更多队伍!',
                            duration: 2000
                        });
                    }
                    
                }else if(res.Status == 0){
                    this.$message.error({message:'暂无数据!',duration: 1500,showClose: true,});
                }else{
                    this.$message.error({
                        message:'获取队伍信息失败!',
                        duration: 1500,
                        showClose: true,
                    });
                }
            })
        },

    }
}
</script>
<style lang="scss" scoped>
    ::v-deep .el-table__row.statistics-warning-row {
        background: #ddd;
    }
    ::v-deep .el-card__body{
        padding: 0;
    }
    ::v-deep .el-collapse-item__header{
        text-indent: 24px;
        font-weight: bold;
        font-size: 14px;
    }
    .GameMatch{
        max-width: 1200px;
        margin: 20px auto;
        font-size: 16px;
    }
    .GameMatch_header{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .GameMatch_box{
        width: 100%;
    }
    .GameMatch_box_data{
        margin-top: 20px;
    }
    .activeCLass{
        color: #409EFF;
        background-color: #ecf5ff;
        border-color: #c6e2ff; 
        // outline-color: rgb(64, 158, 255); 
    }
    .padding_obe{
        padding-left: 15px;
    }
    .font_s{
        font-style:oblique ;
    }
    .font_w{
        font-weight: bold;
        text-align: center;
    }
    .font_si{
        font-size: 20px;
    }
    // .text_c{
    //     text-align: center;
    // }
    .fold_class{
        padding: 0 1rem;
    }
    .staff_class{
        // padding: 0 1rem;
        text-align: left;
    }

</style>